export default __webpack_public_path__ + "locales/sq-AL/HotkeysPanel.json?hash=9505f8a6f7295dc1ffc7b7bacf4597d3";